import * as todo from "./todo";
import * as fetchToDo from "./fetchToDo";
import { initialState as toDoInitialState, ToDoRequestInfoState } from "./todo";
import { initialState as fetchToDoInitialState, FetchToDoInfoState } from "./fetchToDo";
import reduceReducers from "reduce-reducers";


export const Types: { [key: string]: any } = {
    ...todo.Types,
    ...fetchToDo.Types
};

export const Actions: { todo: typeof todo.Actions, fetchToDo: typeof fetchToDo.Actions } = {
    todo: todo.Actions,
    fetchToDo: fetchToDo.Actions
};

export const toDoRequestReducer = reduceReducers<ToDoRequestInfoState>(
    toDoInitialState,
    todo.default as any
);

export const fetchToDoRequestReducer = reduceReducers<FetchToDoInfoState>(
    fetchToDoInitialState,
    fetchToDo.default as any
);

export default {
    toDo: toDoRequestReducer,
    fetchToDo: fetchToDoRequestReducer
};